import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { detect } from 'detect-browser';
import Main from './main/index';
import store from './store';
import './i18n';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './services/Auth/AuthConfig';

// CRITICAL: Import AuthProvider to trigger immediate redirect processing
// This ensures MSAL processes the redirect before React Router renders
import './services/Auth/AuthProvider';

const msalInstance = new PublicClientApplication(msalConfig);
const browser = detect();
const container = document.getElementById('root');
const root = createRoot(container);

const renderApp = () => {
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <Main />
        </MsalProvider>
      </BrowserRouter>
    </Provider>
  );
};

const renderBrowserNotSupportedError = () => {
  root.render(
    <div>
      This browser <span>{`(${browser.name} ${browser.version})`}</span> is not
      supported. Please use a modern browser like{' '}
      <a href="https://www.google.com/chrome/">Chrome</a>
    </div>
  );
};

const supportBrowsers = [
  'chrome',
  'firefox',
  'edge',
  'edge-chromium',
  'safari',
  'ios',
  'ie',
];

if (browser) {
  if (supportBrowsers.indexOf(browser.name) > -1) {
    if (
      browser.name === 'ie' &&
      parseInt(browser.version.split('.')[0], 10) < 11
    ) {
      renderBrowserNotSupportedError();
    } else {
      renderApp();
    }
  } else {
    renderBrowserNotSupportedError();
  }
}
